import $ from 'jquery';
import Swiper, { Pagination, Navigation } from 'swiper';

function initImagesSlider() {
  $(function () {
    if ($('.slider-block').length <= 0) {
      return;
    }

    $('.images-slider').each(function () {
      const slider = $(this).find('.slider-block');
      const pagination = $(this).find('.swiper-pagination');
      const columnsQtt = slider.data('columns');
      new Swiper(slider.get(0), {
        modules: [Pagination],
        slidesPerView: 1, // Default value for large screens
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: pagination.get(0),
          clickable: true,
        },
       
        watchOverflow: false, // Automatically hide pagination if all slides fit
        breakpoints: {
          576: {
            slidesPerView: 1, // Mobile
          },
          768: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: columnsQtt, // Desktop
          },
        },
        on: {
          
        }
      });
    });
    
  });
}

export { initImagesSlider };
